import { useSyncExternalStore } from 'react';

import { isChatTurnTracked, subscribeChatTracker } from './chatTaskTracker';

export function useTrackedChatTurn(proposalId: number): boolean {
  return useSyncExternalStore(subscribeChatTracker, () =>
    isChatTurnTracked(proposalId)
  );
}
